module.exports = __webpack_public_path__ + "img/stena06.83a17816.jpg";